<template>
  <div class="container">
    <div class="cart-place">
      <span class="cart-place-arrow">↑</span>
      <p>Приложите карту</p>
    </div>
    <div data-v-71a74482=""
         class="footer"><svg data-v-71a74482=""
           viewBox="0 0 105 36"
           fill="none"
           xmlns="http://www.w3.org/2000/svg"
           class="footer__logo"><path data-v-71a74482="" fill-rule="evenodd" clip-rule="evenodd" d="M49.977 27.873c.673 0-5.01.417-7.738-3.34l2.97-2.756c1.057 1.235 2.604 2.21 4.667 2.21 1.576 0 3.287-.558 3.408-1.743.1-.974-.556-1.446-1.589-1.681-.963-.22-3.356-.348-4.741-.598-1.3-.235-2.64-.648-3.627-1.822-2.199-2.615-.498-5.93-.836-5.093.687-1.702 2.712-3.776 6.906-3.776-.672 0 4.32-.425 6.942 2.613l-2.483 2.735c-1.37-.997-2.294-1.462-4.358-1.462-1.575 0-3.287.441-3.408 1.627-.1.986.574 1.575 1.632 1.807.8.175 2.985.215 4.6.493 1.332.23 2.694.693 3.622 1.65.874.902 1.22 1.985 1.224 3.51-.049 1.123-.846 5.626-7.191 5.626zm48.398-2.842s-1.626 4.49-2.189 5.934c-.476 1.223-.934 2.14-1.691 2.946-1.267 1.345-3.318 2.087-5.12 2.087-.728 0-3.576.133-5.906-1.907l2.783-2.625c.57.379 1.295.634 2.313.732 1.023.098 2.268-.128 2.954-1.023.501-.653.913-1.42 1.091-1.988.118-.37-.03-1.073-.29-1.703-1.558-3.805-7.4-17.892-7.4-17.892l4.792-.026 5.043 12.996c.327-.919.548-1.532.548-1.532l4.24-11.482 4.606-.005-5.774 15.488zM32.784 9.65l-.035 3.725c-2.336-.581-4.171-.103-5.296.837-.889.742-1.557 2.209-1.557 3.974l.008 9.159-4.479.005V9.831l4.48-.737v2.01c.053-.109.122-.21.205-.3.88-.984 3.709-1.912 6.674-1.153zm6.803 8.4v9.295l-4.479.005V9.831l4.48-.737v8.957zM14.315 26.5a9.664 9.664 0 01-9.552.004 9.439 9.439 0 01-3.48-3.415C.427 21.652 0 20.03 0 17.757V1.085L4.35.26v10.422c.807-.874 3.019-1.612 5.193-1.612 4.088 0 6.464 1.567 8.231 4.58a9.399 9.399 0 010 9.431 9.393 9.393 0 01-3.46 3.42zM9.652 12.895c3.107 0 5.34 2.568 5.34 5.497a5.279 5.279 0 01-1.564 3.747 5.36 5.36 0 01-3.776 1.552 5.36 5.36 0 01-3.776-1.552 5.279 5.279 0 01-1.564-3.747c0-2.93 2.244-5.497 5.34-5.497zm73.531 14.401l-4.716.007V1.008L83.183 0v27.296zm-6.658-.05l-4.93.039-5.863-7.812L64.1 21.14v6.157l-4.349.007V1.008l4.35-.826v15.561l6.361-6.22 4.992.026-6.865 7.008 7.936 10.69z" fill="#000"></path><path data-v-71a74482="" fill-rule="evenodd" clip-rule="evenodd" d="M49.977 27.873c.673 0-5.01.417-7.738-3.34l2.97-2.756c1.057 1.235 2.604 2.21 4.667 2.21 1.576 0 3.287-.558 3.408-1.743.1-.974-.556-1.446-1.589-1.681-.963-.22-3.356-.348-4.741-.598-1.3-.235-2.64-.648-3.627-1.822-2.199-2.615-.498-5.93-.836-5.093.687-1.702 2.712-3.776 6.906-3.776-.672 0 4.32-.425 6.942 2.613l-2.483 2.735c-1.37-.997-2.294-1.462-4.358-1.462-1.575 0-3.287.441-3.408 1.627-.1.986.574 1.575 1.632 1.807.8.175 2.985.215 4.6.493 1.332.23 2.694.693 3.622 1.65.874.902 1.22 1.985 1.224 3.51-.049 1.123-.846 5.626-7.191 5.626zm48.398-2.842s-1.626 4.49-2.189 5.934c-.476 1.223-.934 2.14-1.691 2.946-1.267 1.345-3.318 2.087-5.12 2.087-.728 0-3.576.133-5.906-1.907l2.783-2.625c.57.379 1.295.634 2.313.732 1.023.098 2.268-.128 2.954-1.023.501-.653.913-1.42 1.091-1.988.118-.37-.03-1.073-.29-1.703-1.558-3.805-7.4-17.892-7.4-17.892l4.792-.026 5.043 12.996c.327-.919.548-1.532.548-1.532l4.24-11.482 4.606-.005-5.774 15.488zM32.784 9.65l-.035 3.725c-2.336-.581-4.171-.103-5.296.837-.889.742-1.557 2.209-1.557 3.974l.008 9.159-4.479.005V9.831l4.48-.737v2.01c.053-.109.122-.21.205-.3.88-.984 3.709-1.912 6.674-1.153zm6.803 8.4v9.295l-4.479.005V9.831l4.48-.737v8.957zM14.315 26.5a9.664 9.664 0 01-9.552.004 9.439 9.439 0 01-3.48-3.415C.427 21.652 0 20.03 0 17.757V1.085L4.35.26v10.422c.807-.874 3.019-1.612 5.193-1.612 4.088 0 6.464 1.567 8.231 4.58a9.399 9.399 0 010 9.431 9.393 9.393 0 01-3.46 3.42zM9.652 12.895c3.107 0 5.34 2.568 5.34 5.497a5.279 5.279 0 01-1.564 3.747 5.36 5.36 0 01-3.776 1.552 5.36 5.36 0 01-3.776-1.552 5.279 5.279 0 01-1.564-3.747c0-2.93 2.244-5.497 5.34-5.497zm73.531 14.401l-4.716.007V1.008L83.183 0v27.296zm-6.658-.05l-4.93.039-5.863-7.812L64.1 21.14v6.157l-4.349.007V1.008l4.35-.826v15.561l6.361-6.22 4.992.026-6.865 7.008 7.936 10.69z" fill="#fff"></path><path data-v-71a74482="" fill-rule="evenodd" clip-rule="evenodd" d="M35.624 7.013c1.675-2.482 5.621-2.775 5.621-2.775s1.232 3.731-.444 6.214c-1.675 2.482-5.621 2.775-5.621 2.775s-1.231-3.732.444-6.214z" fill="#5FDA3E"></path></svg></div>
  </div>
</template>

<script>
    export default {
        name: 'Pay',
        data() {
            return {
                timeout: null,
            };
        },
        created() {

        },
        mounted() {
            let elem = this;
            this.timeout = setTimeout(function () {
                elem.$router.push('/');
            }, this.$store.state.timeout);
        },
        methods: {

        },
    };
</script>

<style>
.cart-place {
  background: #39e569;
  border-radius: 0 0 18px 0;
  position: relative;
  display: inline-block;
  width: 50vw;
  padding: 10vw;
  margin-top: 34px;
  margin-left: -18px;
}
.cart-place p {
  position: relative;
  left: 3vw;
  top: 3vw;
  letter-spacing: 0.3vw;
  font-weight: 500;
  font-size: 4vw;
  line-height: 140%;
  text-transform: uppercase;
  text-shadow: 0px 2px 6px rgba(51, 57, 63, 0.3);
  color: #fff;
}
.cart-place .cart-place-arrow {
  font-size: 30px;
  color: #fff;
  text-align: left;
  margin-left: 10px;
}
.footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  margin-top: 300px;
}
.footer__logo {
  width: 50vw;
}
</style>
